module.exports = __webpack_public_path__ + "src/assets/img/door_right.887046d2.svg";